import React from 'react';
import PropTypes from 'prop-types';
import css from './SuggestedUses.module.css';
import { FormattedMessage } from 'react-intl';

const NUM_COLUMNS = 3;

const SuggestedUses = ({ uses }) => {
  if (!uses || uses.length === 0) return null;

  const perColumn = Math.ceil(uses.length / NUM_COLUMNS);
  const columns = Array.from({ length: NUM_COLUMNS }, (_, i) =>
    uses.slice(i * perColumn, i * perColumn + perColumn)
  );

  return (
    <section className={css.panel} aria-labelledby="suggested-uses-heading">
      <h3 id="suggested-uses-heading">
        <FormattedMessage
          id="SuggestedUses.heading"
          defaultMessage="Suggested Uses for This Item"
        />
      </h3>
      <div className={css.grid} role="list">
        {columns.map((column, colIndex) => (
          <ul
            className={css.column}
            key={colIndex}
            data-testid="suggested-use-column"
          >
            {column.map((use, i) => (
              <li key={i} data-testid="suggested-use-item">
                <span className={css.icon}>
                  <i
                    style={{ fontSize: 23, color: '#F2704E' }}
                    className="ri-checkbox-circle-fill"
                    aria-hidden="true"
                  ></i>
                </span>
                <span>{use}</span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </section>
  );
};

SuggestedUses.propTypes = {
  uses: PropTypes.arrayOf(PropTypes.string),
};

export default SuggestedUses;
